<template>
  <div class="host-project">
    <div class="project-logo">
      <img src="@static/img/logo.png" alt="PCHI" />
    </div>
    <gHead></gHead>

    <div class="project-content">
      <p class="title">项目管理</p>
      <div class="project-list">
        <div class="project-list-add" @click="show = true">
          <i class="icon iconfont icon-tianjia"></i>
          <p style="font-size: 18px; color: #333; margin: -20px 0 20px 0">添加</p>
          <p style="font-size: 16px; color: #4d4d4d">展会/会议/节事/线上</p>
        </div>
        <div v-for="(item, index) in exList" :key="index" class="project-mask">
          <div class="project-list-one">
            <img class="logo" :src="item.logo" />
            <p>{{ item.name }}</p>
            <img
              v-if="item.showType === -1"
              class="online"
              src="@assets/img/project-online.png"
            />
          </div>
          <div class="project-list-control">
            <p @click="enterHost(item)">进入工作台</p>
            <div class="btn">
              <!-- <i class="icon iconfont icon-erweima1"></i> -->
              <i class="icon iconfont icon-peizhi" @click="enterExInfo(item)"></i>
              <Poptip
                confirm
                title="确认删除?"
                style="color: #333"
                ok-text="确认"
                @on-ok="delProject(item)"
              >
                <i class="icon iconfont icon-trash"></i>
              </Poptip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <copyright />

    <projectAdd :show="show" @finish="init()" @close="show = false" />
  </div>
</template>

<script>
import gHead from "@components/gHead/gHead";
import projectAdd from "./components/project-add";
import { mapMutations, mapActions } from "vuex";
import copyright from "@components/copyright/copyright";
import axios from "axios";

export default {
  name: "host-project",
  data() {
    return {
      show: false,
      agentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
      exList: [],
    };
  },
  components: {
    gHead,
    projectAdd,
    copyright,
  },

  created() {

    document.title = "中国国际化妆品个人及家庭护理用品原料展览会（PCHi）";
    this.init();
  },
  methods: {
    ...mapMutations({
      setHostExhibition: "hostSetModule/setHostExhibition",
    }),
    ...mapActions({
      getExByAgentId: "hostSetModule/getExByAgentId",
      delExById: "hostSetModule/delExById",
    }),
    async init() {
      let res = await this.getExByAgentId({
        AgentId: this.agentId,
        pageSize: 1000,
      });
      if (res && res.items.length > 0) {
        this.exList = res.items;
        console.log(this.exList);
      }
    },

    // initAxios() {
    //   axios
    //     .post(`https://zwyd-api.pharmchina.com.cn/api/exhibition/GetByAgent`, {
    //       AgentId: this.agentId,
    //       pageSize: 1000,
    //     },this.$store.state.header)
    //     .then((res) => {
    //       this.exList = res.data.items;
    //     })
    //     .catch((err) => {});
    // },

    async delProject(item) {
      let bool = await this.delExById(item.id);
      if (!bool) {
        this.$Message.error("删除失败，请重新尝试");
      } else {
        this.$Message.success("删除成功！");
        this.init();
      }
    },
    enterHost(item) {
      this.setHostExhibition(item);
      this.$router.push("/host/index/home");
    },
    enterExInfo(item) {
      this.setHostExhibition(item);
      this.$router.push("/host/index/set/base");
    },
  },
};
</script>

<style lang="scss" scoped>
.host-project {
  .project-logo {
    position: absolute;
    height: 64px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
    img {
      height: 35px;
      max-width: 98%;
      max-height: 98%;
    }
  }
  .project-content {
    width: 1000px;
    min-height: 700px;
    margin: 50px auto;
    .title {
      width: 100%;
      font-weight: bold;
      border-bottom: 1px solid #ddd;
      font-size: 18px;
      color: #333;
    }
    .project-list {
      width: 1100px;
      margin-top: 50px;
      display: flex;
      flex-wrap: wrap;
      .project-mask {
        position: relative;
        margin: 0 50px 50px 0;
        &:hover {
          .project-list-control {
            display: block;
          }
        }
      }
      &-add {
        width: 300px;
        height: 240px;
        background-color: #fff;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 50px 50px 0;
        i {
          font-size: 60px;
          margin-top: 40px;
          color: #999;
        }
      }
      &-one {
        width: 300px;
        height: 240px;
        background-color: #fff;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .logo {
          width: 128px;
          // height: 128px;
          border-radius: 50%;
          margin-bottom: 30px;
        }
        p {
          width: 100%;
          text-align: center;
          color: #333;
          font-size: 16px;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 10px;
        }
        .online {
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 5px 0 0 0;
        }
        .top {
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 0 5px 0 0;
        }
      }
      &-control {
        display: none;
        width: 300px;
        height: 240px;
        background-color: #fff;
        border-radius: 5px;
        margin: 0 50px 50px 0;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        p {
          text-align: center;
          font-size: 18px;
          color: #d53b76;
          line-height: 220px;
        }
        .btn {
          width: 100%;
          padding: 0 20px;
          display: flex;
          justify-content: space-around;
          position: absolute;
          bottom: 20px;
          i {
            color: #bfbfbf;
            font-size: 30px;
            &:hover {
              color: #d53b76;
            }
          }
        }
      }
    }
  }
}
</style>
